
window.crea_datatable = function (
  tabla,
  url,
  ar_columnas = [],
  ar_order = [],
  ar_colvis = [],
  ar_colocu = [],
  ar_panelvis = [],
  ar_panelocu = [],
  ar_colexp = [],
  isAdmin = false,
  isExporta = false,
  panel = null,
  agrupa = false,
  colagrupa = null,
  numcol = 1,
  titulo = '',
  ar_callback = null,
  ar_fn_agrupa = null,
  ar_opciones = {},
  confButtons = null,
  cargaAjax = true,
  numFilas = 0
  ) {
  
/*    if (!document.getElementById('dtsp-custom-style')) {

        let style = document.createElement('style');
        style.id = 'dtsp-custom-style';

        style.innerHTML = `
        .dtsp-panesContainer{
            color:var(--colorCliente6);
            background-color:var(--colorCliente3);
            border:1px solid #ccc;
            border-radius:8px;
            box-shadow:0 2px 5px var(--colorCliente7);
            margin:5px;
            padding:5px !important;
        }

        .dtsp-panesContainer .dtsp-searchPane{
            background-color:var(--colorCliente1);
            border:1px solid var(--colorCliente6);
            border-radius:5px;
            margin:5px;
            padding:5px;
        }

        .dtsp-paneInputButton{
            background:none;
            border:none;
            box-shadow:none;
            padding-right:0;
        }

        .dtsp-search{
            background:#fff;
            border:1px solid #ccc;
            border-radius:4px;
        }

        .dtsp-orderPane{
            display:none !important;
        }
        `;

        document.head.appendChild(style);
      }*/

    // ==========================
    // Destruir tabla existente
    // ==========================

    if ($.fn.DataTable.isDataTable(tabla)) {
      $(tabla).DataTable().clear().destroy();
    }

    // ==========================
    // Callback por defecto
    // ==========================

    if (!ar_callback) {
      ar_callback = function () {};
    }

    if (!ar_fn_agrupa) {
      ar_fn_agrupa = function (rows, group) {
        return $(`
          <tr class="group group-start"
          style="background:gray;color:white;font-weight:bold;">
          <td colspan="${numcol}">
          ${titulo}: ${group}
          </td>
          </tr>
          `);
      };
    }

    // ==========================
    // Dom Layout
    // ==========================

    // let cadpanel = panel || 'lBfiprtip';
    let cadpanel =
    (typeof panel === 'string' && panel.trim() !== '')
    ? panel
    : `
    <'row'<'col-md-12'P>>
    <'row align-items-center pt-2'
    <'col-md-2'l>
    <'col-md-8 text-center'B>
    <'col-md-2'f>>
    <'row'
    <'col-md-6'i>
    <'col-md-6'p>>
    <'row'
    <'col-md-12'rt>>
    <'row'
    <'col-md-6'i>
    <'col-md-6'p>>
    `;

    // ==========================
    // Botones
    // ==========================

    let ar_botones = [];

    if (confButtons !== null) {

      ar_botones = confButtons;

    } else {

      if (isExporta) {
        ar_botones.push(exportToExcel(ar_colexp));
      }

      if (isAdmin) {
        ar_botones.push(exportToPDF(baseUrl));
      }
    }

    // ==========================
    // Ajax
    // ==========================

    let ajaxConfig = cargaAjax
    ? {
      url: url,
      type: 'GET',
      dataSrc: ''
    }
    : null;

    // ==========================
    // Crear DataTable
    // ==========================

    let tblDT = $(tabla).DataTable({

      processing: true,
      serverSide: false,
      searching: true,
      destroy: true,
      responsive: true,
      autoWidth: false,
      deferRender: true,

      pageLength: 20,

      lengthMenu:
      numFilas === 0
      ? [10,20,30,50,100,150]
      : [10,20,30,50,100,150,-1],

      order: ar_order,

      ajax: ajaxConfig,

      columns: ar_columnas,

      rowCallback: ar_callback,

      rowGroup: agrupa
      ? {
        dataSrc: colagrupa,
        startRender: ar_fn_agrupa
      }
      : false,

      searchPanes: {
        layout: 'columns-3',
        cascadePanes: true,
        initCollapsed: true
      },

      columnDefs: [
      {
        targets: ar_colvis,
        visible: true
      },
      {
        targets: ar_colocu,
        visible: false
      },
      {
        searchPanes: {
          show: true
        },
        targets: ar_panelvis
      },
      {
        searchPanes: {
          show: false
        },
        targets: ar_panelocu
      }
      ],

      dom: cadpanel,

      buttons: ar_botones,

      language: {
        processing: "<i class='fa fa-spinner fa-spin'></i> Cargando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "No existen registros",
        sInfo: "Mostrando _START_ a _END_ de _TOTAL_",
        sInfoEmpty: "Mostrando 0 a 0 de 0",
        sInfoFiltered: "(filtrado de _MAX_ registros)",
        sSearch: "Buscar:",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },

      ...ar_opciones

    });

    // ==========================
    // Gestión de botones
    // ==========================

    if (tblDT.buttons().count() > 0) {

      if (isAdmin || isExporta) {

        tblDT.buttons().enable();

      } else {

        tblDT.buttons().remove();
      }
    }

    return tblDT;
  };

  window.crea_datatable_old = function (
    tabla,
    url,
    ar_columnas = [],
    ar_order = [],
    ar_colvis = [],
    ar_colocu = [],
    ar_panelvis = [],
    ar_panelocu = [],
    ar_colexp = [],
    isAdmin = false,
    isExporta = false,
    panel = null,
    agrupa = false,
    colagrupa = null,
    numcol = 1,
    titulo = '',
    ar_callback = null,
    ar_fn_agrupa = null,
    ar_opciones = {},
    confButtons = null,
    cargaAjax = true,
    numFilas = 0
    ) {

    var style = document.createElement('style');
    style.innerHTML = `
    .dtsp-panesContainer {
      color: var(--colorCliente3);
      background-color: var(--colorCliente2); /* Fondo claro */
      border: 1px solid #ccc;    /* Borde */
      border-radius: 8px;       /* Bordes redondeados */
      box-shadow: 0 2px 5px var(--colorCliente1); /* Sombra */
      margin:5px;
      padding: 5px !important;
    }

    .dtsp-panesContainer .dtsp-searchPane {
      background-color: var(--colorCliente5); /* Fondo azul claro */
      border: 1px solid var(--colorCliente3); /* Borde */
      border-radius: 5px;        /* Bordes redondeados */
      margin: 5px;
      padding: 5px;
    }

    .dtsp-paneInputButton {
      background: none;
      border: none;
      box-shadow: none;
      padding-right: 0;
    }
    .dtsp-paneInputButton::placeholder {
      color: #000;
    }
    .dtsp-search {
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
    }

    .dtsp-searchPane dtsp-countButton{
      display: none !important; /* Oculta los botones de ordenamiento */
    }

    .dtsp-searchPane .dtsp-titleRow button.dtsp-titleButton {
      display: inline-block !important; /* Muestra los botones de colapsar/desplegar */
    }

    .dtsp-orderPane {
      display: none !important; /* Oculta los botones Aa y Nn */
    }
    `;


    document.head.appendChild(style);

    var ar_order = ar_order || [];
    var ar_colvis = ar_colvis || [];
    var ar_colocu = ar_colocu || [];

    if ($.fn.DataTable.isDataTable(tabla)) {
      jQuery(tabla).DataTable().clear().destroy();
    }

    if (ar_callback == null) {
      ar_callback = function (row, data, dataIndex) {};
    }

    if (ar_fn_agrupa == null) {
      ar_fn_agrupa = function (rows, group) {
        return $('<tr class="group group-start" style="color: white; background-color:gray; font-weight:bold;"><td class="column-title3" colspan="' + numcol + '">' + titulo + ' : ' + group + '</td></tr>');
      }
    }

    anchoButtons();
    var cadpanel = panel || `
    <'row'<'col-md-12'P>>
    <'row'<'col-md-3'l><'col-md-6 align-content-center 'B><'col-md-3'f>>
    <'row'<'col-md-6'i><'col-md-6'p>>
    <'row'<'col-md-12'rt>>
    <'row'<'col-md-6'i><'col-md-6'p>>
    `;

    if (panel) {
      cadpanel = panel; 
    } else {
      cadpanel = 'lBfiprtip';
    }

    if (ar_botones == null) {
      cadpanel = `
      <'row'<'col-md-12'P>>
      <'row'<'col-md-12'
      <'row'<'col-md-3'l><'col-md-6 align-content-center 'B><'col-md-3'f>>
      >>
      <'row'<'col-md-6'i><'col-md-6'p>>
      <'row'<'col-md-12'rt>>
      <'row'<'col-md-6'i><'col-md-6'p>>
      `;
    }

    var opciones = ar_opciones || {};
    var ar_botones = confButtons || [];

    var ar_botones = [];
    if (isExporta) {
      ar_botones.push(exportToExcel(ar_colexp));
    }
    if (isAdmin) {
      ar_botones.push(exportToPDF(baseUrl));
    }

    if (confButtons == null) {
      var ar_botones = [];
      if (isExporta) {
        ar_botones.push(exportToExcel(ar_colexp));
      }
      if (isAdmin) {
        ar_botones.push(exportToPDF(baseUrl));
      }
    } else {
      ar_botones = confButtons;
    }

    var dataAjax = {};
    if (cargaAjax === true || cargaAjax === null) {
      dataAjax = {
        ajax: {
          url: url,
          type: "GET",
          dataSrc: ""
        }
      };
    }


    $('button.dtsp-paneButton.dtsp-countButton.dtsp-disabledButton').remove();
    $(tabla).DataTable({
      processing:true,
      serverside: true,
      searching: true,
      destroy: true,
      pageLength: 20,
      responsive: true, 
      autoWidth: false,
      deferRender: true,
      lengthMenu: numFilas === 0 ? [10, 20, 30, 50, 100, 150] : [10, 20, 30, 50, 100, 150, -1],
      order: ar_order || [],
      rowGroup: agrupa ? {
        dataSrc: [colagrupa],
        startRender: ar_fn_agrupa
      } : false,
      'ajax'       : {
        "url"    : url,
        "type"   : "GET",
        "dataSrc": "",
      },
      columns: ar_columnas || [],
      rowCallback: ar_callback || function () {},
      searchPanes: {
        layout: 'columns-3',
        cascadePanes: true,
        initCollapsed: true,
        orderable: false,
        show: true,
        control: false,
        paneIndex: 1
      },
      columnDefs: [
      { targets: ar_colvis || [], visible: true },
      { targets: ar_colocu || [], visible: false },
      { searchPanes: { show: true }, targets: ar_panelvis || [] },
      { searchPanes: { show: false }, targets: ar_panelocu || [] }
      ],
      dom: cadpanel || 'Bfrtip',
      buttons: confButtons || [],
      language: {
        "processing": "<span class='fa-stack fa-lg'><i class='fa fa-spinner fa-spin fa-stack-2x fa-fw'></i></span><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Cargando datos del servidor ...",
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "No se encontraron resultados",
        "sEmptyTable": "Ningún dato disponible en esta tabla =(",
        "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix": "",
        "sSearch": "Buscar:",
        "sUrl": "",
        "sInfoThousands": ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
          "sFirst": "Primero",
          "sLast": "Último",
          "sNext": "Siguiente",
          "sPrevious": "Anterior"
        },
        "oAria": {
          "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
          "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        "buttons": {
          "copy": "Copiar",
          "colvis": "Visibilidad",
          "print": "Imprimir",
          "pdf": "PDF"
        },
        "searchPanes": {
          title: {
            _: 'Filtros seleccionados - %d',
            0: 'Ningún filtro seleccionado'
          },
          collapse: {
            0: 'Opciones seleccionados',
            1: 'Buscando (1 seleccionado)',
            _: 'Opciones seleccionados (%d)'
          },
          collapseMessage: 'Ocultar Filtros',
          showMessage: 'Mostrar Filtros',
          clearMessage: 'Limpiar Filtros',
          "emptyPanes": "Sin paneles de búsqueda",
          "loadMessage": "Cargando paneles de búsqueda"
        }
      }
    });


    tblDT = $(tabla).DataTable();
    console.log('isAdmin : ', isAdmin);
    console.log('isExporta : ', isExporta);
    if((isAdmin) || ( isExporta)){
      tblDT.button( 0 ).enable( true );
      tblDT.button( 1 ).enable( true );
    }else {
      tblDT.button( '.excel' ).remove();
      tblDT.button( '.pdf' ).remove();
      //console.log('Button 0 should be DISABLED')
    }

  };



  window.exportToExcel = function (ar_colexp) {
    return {
      extend: 'excelHtml5',
      text: '<i class="fa-regular fa-file-excel"></i>&nbsp;&nbsp;Excel',
      titleAttr: 'Excel',
      className: 'bg-success text-white excel',
      exportOptions: {
        columns: function (idx, data, node) {
          if ($.inArray(idx, ar_colexp) < 0) {
            return false;
          }
          return true;
        }
      },
    };
  }


  window.exportToPDF = function (baseUrl) {
    return {
      text: '<i class="fa-regular fa-file-pdf"></i>&nbsp;&nbsp;PDF',
      titleAttr: 'Exportar a PDF',
      className: 'bg-danger text-white pdf',
      action: function (e, dt, button, config) {
        try {
                // Obtener filas seleccionadas o filtradas
                let selectedRows = dt.rows({ selected: true }).data().toArray();
                let filteredRows = dt.rows({ filter: 'applied' }).data().toArray();
                let datapdf = selectedRows.length > 0 ? selectedRows : filteredRows;

                // Validar si hay datos
                if (datapdf.length === 0) {
                  alert("No hay datos para exportar a PDF.");
                  return;
                }

                // Ordenar datos
                datapdf.sort((a, b) => {
                  if (a.nmoneda && b.nmoneda) {
                    if (a.nmoneda === b.nmoneda) {
                      if (a.nempresa && b.nempresa) {
                        if (a.nempresa === b.nempresa) {
                          if (a.fecha && b.fecha) {
                            return new Date(a.fecha) - new Date(b.fecha);
                          }
                          return a.fecha ? -1 : 1;
                        }
                        return a.nempresa.localeCompare(b.nempresa);
                      }
                      return a.nempresa ? -1 : 1;
                    }
                    return a.nmoneda.localeCompare(b.nmoneda);
                  }
                  return a.nmoneda ? -1 : 1;
                });

                // Verificar CSRF Token
                let csrfToken = $('meta[name="csrf-token"]').attr('content');
                if (!csrfToken) {
                  console.error("CSRF Token no encontrado en el meta-tag.");
                  return;
                }

                // Crear formulario dinámico
                let form = $('<form>', {
                  action: baseUrl + '/pdfmovim',
                  method: 'POST',
                  target: '_blank'
                })
                .append($('<input>', { name: 'data', value: JSON.stringify(datapdf), type: 'hidden' }))
                .append($('<input>', { name: '_token', value: csrfToken, type: 'hidden' }));

                // Enviar formulario
                $('body').append(form);
                form.submit();
                form.remove(); // Limpieza después de enviar

              } catch (err) {
                console.error("Error al exportar a PDF:", err);
              }
            }
          };
        };


        window.goBack = function () {
          window.history.back();
        }


        window.setPalette = function(){
          var palette=[];
          palette[0] = getComputedStyle(document.documentElement).getPropertyValue('--colorCliente1');
          palette[1] = getComputedStyle(document.documentElement).getPropertyValue('--colorCliente2');
          palette[2] = getComputedStyle(document.documentElement).getPropertyValue('--colorCliente3');
          palette[3] = getComputedStyle(document.documentElement).getPropertyValue('--colorCliente4');
          palette[4] = getComputedStyle(document.documentElement).getPropertyValue('--colorCliente5');

          var color1 = tinycolor(hexToRgb(palette[0])).toHexString().slice(1);
          var color2 = tinycolor(hexToRgb(palette[1])).toHexString().slice(1);
          var color3 = tinycolor(hexToRgb(palette[2])).toHexString().slice(1);
          var color4 = tinycolor(hexToRgb(palette[3])).toHexString().slice(1);
          var color5 = tinycolor(hexToRgb(palette[4])).toHexString().slice(1);

/*
var color1 = tinycolor(palette[0]).toHexString();
var color2 = tinycolor(palette[1]).toHexString();
var color3 = tinycolor(palette[2]).toHexString();
var color4 = tinycolor(palette[3]).toHexString();
var color5 = tinycolor(palette[4]).toHexString();
*/


  // alt versions of dark and light colors
  var colorLightLight = tinycolor('#'+color1).lighten(15).toHexString().slice(1);
  var colorLight = tinycolor('#'+color1).darken(10).desaturate(10).toHexString().slice(1);
  var colorLight2 = tinycolor('#'+color1).darken(35).desaturate(20).toHexString().slice(1);
  
  var colorDark = tinycolor('#'+color5).darken(10).desaturate(4).toHexString().slice(1);
  var colorDark2 = tinycolor('#'+color5).darken(30).desaturate(4).toHexString().slice(1);
  
  var colorDarkLight = tinycolor('#'+color5).lighten(70).toHexString().slice(1);
  
  // bootstrap colors
  
  var main = tinycolor('#'+color3).toRgb();
  
  var success = tinycolor('#4caf50').toRgb();
  success.r = 0.7*success.r + 0.3*main.r;
  success.g = 0.7*success.g + 0.3*main.g;
  success.b = 0.7*success.b + 0.3*main.b;
  
  var warning = tinycolor('#ff9800').toRgb();
  warning.r = 0.7*warning.r + 0.3*main.r;
  warning.g = 0.7*warning.g + 0.3*main.g;
  warning.b = 0.7*warning.b + 0.3*main.b;
  
  var danger = tinycolor('#f44336').toHsv();
  danger.r = 0.7*danger.r + 0.3*danger.r;
  danger.g = 0.7*danger.g + 0.3*danger.g;
  danger.b = 0.7*danger.b + 0.3*danger.b;
  
  var location = window.location.href+'?';
  if(window.location.href.indexOf('?') > -1){
    location = window.location.href.slice(0,window.location.href.indexOf('?'))+'?';
  }
  
  var data = {
    'light': color1,
    'dark': color5,
    'light-secondary': colorLight,
    'dark-secondary':colorDark,
    'light-tertiary': colorLight2,
    'dark-tertiary': colorDark2,
    'light-light': colorLightLight,
    'dark-light': colorDarkLight,
    
    'accent': tinycolor('#'+color4).toHexString().slice(1),
    'accent-secondary': tinycolor('#'+color4).lighten(10).toHexString().slice(1),
    
    'primary': color3,
    'info': color2,
    'success': tinycolor(success).toHexString().slice(1),
    'warning': tinycolor(warning).toHexString().slice(1),
    'danger': tinycolor(danger).toHexString().slice(1),
    
    'primary-secondary': tinycolor('#'+color1).lighten(30).toHexString().slice(1),
    'info-secondary': tinycolor('#'+color2).lighten(30).toHexString().slice(1),
    'success-secondary': tinycolor(success).lighten(30).toHexString().slice(1),
    'warning-secondary': tinycolor(warning).lighten(30).toHexString().slice(1),
    'danger-secondary': tinycolor(danger).lighten(30).toHexString().slice(1)
  };
  
  return(data);
}

function hexToRgb(hex) {
  // Elimina el símbolo '#' si está presente
  hex = hex.replace(/^#/, '');

  // Divide el valor hexadecimal en pares de caracteres
  var r = parseInt(hex.slice(0, 2), 16); // Componente rojo
  var g = parseInt(hex.slice(2, 4), 16); // Componente verde
  var b = parseInt(hex.slice(4, 6), 16); // Componente azul

  // Devuelve la cadena en formato RGB
  return 'rgb(' + r + ', ' + g + ', ' + b + ')';
}


function hexToRgb2(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
  parseInt(result[1], 16),
  parseInt(result[2], 16),
  parseInt(result[3], 16)
  ] : null;
}

function rgbToHex(rgb){
 return "#" +
 ("0" + parseInt(rgb[0]).toString(16)).slice(-2) +
 ("0" + parseInt(rgb[1]).toString(16)).slice(-2) +
 ("0" + parseInt(rgb[2]).toString(16)).slice(-2);
}



function encodeQueryData(data) {
 let ret = [];
 for (let d in data)
   ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
 return ret.join('&');
}


window.fondo_pantalla = function()
{
  var images = [
  baseUrl + "/src/images/fondo01.png",
  baseUrl + "/src/images/fondo02.png",
  baseUrl + "/src/images/fondo03.png",
  baseUrl + "/src/images/fondo04.png",
  baseUrl + "/src/images/fondo05.png",
  baseUrl + "/src/images/fondo06.png",
  baseUrl + "/src/images/fondo07.png"
  ];

  var index = 0,oldIndex;

  $(document).ready(function() {

    index = Math.floor((Math.random()*images.length));
    $.backstretch(images[index], {
      fade: 200
    });
        //duration: 3000,
        setInterval(function() {
          oldIndex = index;
          while (oldIndex == index) {
            index = Math.floor((Math.random()*images.length));
          }
          $.backstretch(images[index]);
        }, 7500);

        $(images).each(function() {
          $("<img/>")[0].src = this;
        });
        

      });

}


//////////////////////////////

window.ejecutar = function (code, accion) {
  return new Promise((resolve, reject) => {
    var baseUrl = "{{ url('/') }}"
    var url = accion + '/' + code;
    //console.log(url);
    $.ajax({
      data: {},
      type: "GET",
      dataType: "json",
      url: url,
      success: function(response){
        resolve(response);
      },
      error: function(jqXHR, textStatus, error ) {
        reject(error);
      }
    });
  });
}

window.pregunta = async function (titulo, texto, icono) {
  const result = await Swal.fire({
    title: titulo,
    text: texto,
    icon: icono,
    showCancelButton: true,
    confirmButtonText: 'SI',
    cancelButtonText: 'NO',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });

  if (result.isConfirmed) {
    return true;
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    return false;
  }
} 

window.procesar = async function (code, accion, tabla) {
    // Icon: warning, error, success, info, and question. 
    var rpta = await pregunta(tabla, '¿Desea '+tabla+' ?', 'question');
    if (rpta){
      try {
        var resp = await ejecutar(code, accion);
        //console.log(resp);
        var opc = resp.success;
        var mes = resp.message;
        //console.log(opc, mes);
        
        if (opc) {
          await Swal.fire('¡Acción confirmada!', tabla+' se realizó con éxito.', 'success');
        } else {
          //console.log(mes);
          await Swal.fire('Cancelado', 'Error al ejecutar '+tabla+'\n'+mes, 'error');
        }

        location.reload(true);
      } catch (error) {
        //console.error('Error en la llamada Ajax:', error);
        Swal.fire('Cancelado', 'La acción ha sido cancelada.\n'+error, 'error');
      }
    }
    else{
      Swal.fire('Cancelado', 'La acción ha sido cancelada.', 'error');
    }
  }
  
  window.anchoButtons = function(){
   var anchoDiv1 = $('#datatable_length').width();
   var anchoDiv2 = $('#datatable_filter').width();
   var anchoDiv = $('#datatable_wrapper').width();
   var resul = anchoDiv-anchoDiv1-anchoDiv2;
   var styleElement = document.querySelector('style');

   var ruleIndex = -1;
   for (var i = 0; i < styleElement.sheet.cssRules.length; i++) {
    if (styleElement.sheet.cssRules[i].selectorText === 'div.dt-buttons') {
      ruleIndex = i;
      break;
    }
  }

  if (ruleIndex !== -1) {
    styleElement.sheet.cssRules[ruleIndex].style.width = resul+'px';
  }
}


window.carga_unidades = function(accion, lista){
  var url = accion;
  $.ajax({
    data: {},
    type: "GET",
    dataType: "json",
    async: true,
    url: url,
  })
  .done(function( data, textStatus, jqXHR ) {
    $(lista).html("");
    $(lista).append('<option value="0">Seleccionar Sede del Servicio</option>');
    data.forEach(function (item, index) {
      $(lista).append('<option value="'+item.id+'"> '+item.name+' </option>');
    });
  })
  .fail(function( jqXHR, textStatus, errorThrown ) {
   if ( console && console.log ) {
    console.log( "La solicitud a fallado: " +  textStatus);
  }
});
};

window.carga_lista = function (accion, lista, campos, selec, inicia) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      dataType: "json",
      url: accion
    })
    .done(function (data) {
      $(lista).empty();

      // Opción inicial
      if (inicia) {
        $(lista).append('<option value="">Seleccionar de la lista</option>');
      }

      // Preseleccionar primer item REAL
      if (!inicia && (selec === null || selec === undefined) && data.length > 0) {
        selec = data[0].id;
      }

      data.forEach(function (item) {
        const optionText = campos.map(c => item[c]).join(' ');
        $(lista).append(`
          <option value="${item.id}" ${selec == item.id ? 'selected' : ''}>
          ${optionText}
          </option>
          `);
      });

      resolve(selec);
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.error("Error en carga_lista:", textStatus);
      reject(errorThrown);
    });
  });
};



window.getUser = async function(url){
  var url = url+'/apiUser';

  try {
    const response = await $.ajax({
      data: {},
      type: "GET",
      dataType: "json",
      async: true,
      url: url,
    });

    //console.log(response);
    return response;
  } catch (error) {
    console.error("La solicitud ha fallado:", error);
    throw error; // Propaga el error para que pueda ser manejado por el código que llama a getUser
  }
};



window.upperCase = function(campo){
  var x=document.getElementById(campo).value;
  document.getElementById(campo).value=x.toUpperCase();
}


window.ValidateEmail = function(inputText, errorText) {
  var errorElement = document.getElementById(errorText).value;
  //console.log(inputText, inputText.value, typeof inputText.value);
  if (inputText && inputText.value && typeof inputText.value === 'string') {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (inputText.value.match(mailformat) !== null) {
        // Correo válido
        errorElement.textContent = '';
        return true;
      } else {
        // Correo no válido
        errorElement.textContent = 'Error: El formato del correo no es válido';
        return false;
      }
    } else {
    // Input de correo no válido
    errorElement.textContent = 'Error: Ingresa un correo';
    return false;
  }
}

window.validarNumeroDocumento = function(inputText, errorText) {
  var errorElement = document.getElementById(errorText);
  //console.log(inputText, inputText.value, typeof inputText.value);
  var numeroDocumento = inputText.value;
  var soloNumeros = /^[0-9]+$/;
  if (numeroDocumento.length >= 8 && numeroDocumento.length <= 9 && soloNumeros.test(numeroDocumento)) {
    errorElement.textContent = '';
    return true;
  } else {
    if (numeroDocumento.length >= 8 && numeroDocumento.length <= 9) {
      errorElement.textContent='El número de documento no es correcto.';
      return false;
    } else {
      errorElement.textContent='Número de documento no válido';
      return false;
    }
  }
}



window.mostrarError = function(errorText,mensaje) {
  var errorElement = document.getElementById(errorText);
  errorElement.textContent=mensaje;
}

window.consulta_dni_ante = function(accion, dni, cdni, cnombres, capellidop, capellidom){
  var Url = accion;
    //console.log(Url, dni, cdni, cnombres, capellidop, capellidom);
    //$('.ajaxgif').removeClass('d-none');
    $.ajax({
      type: 'POST',
      url: Url,
      data: 'dni='+dni,
      success: function(datos_dni){
        $('.ajaxgif').addClass('d-none');
        console.log(datos_dni);
        var datos = JSON.parse(datos_dni);
        //var datos = datos_dni;
        
        var nada = 'nada';
        if(datos[message]==="not found"){
          Swal.fire({
            text: "DNI no existe, verifique.",
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        }else{
          var xdni = document.getElementById(cdni);
          xdni.value = datos["numeroDocumento"];
          var xx = document.getElementById(capellidom);
          //console.log(xx);
          if (xx===null){
            var app = document.getElementById(capellidop);
            app.value = datos["apellidoPaterno"]+' '+datos["apellidoMaterno"];
          }else{
            var app = document.getElementById(capellidop);
            app.value = datos["apellidoPaterno"];
            var apm = document.getElementById(capellidom);
            apm.value = datos["apellidoMaterno"];
          }
          var xnom = document.getElementById(cnombres);
          xnom.value = datos["nombres"];
        }
      },
      error: function(){
        return true;
      }
    });
    return false;
  };


  window.consulta_dni2 = function(accion, dni, cdni, cnombres, capellidop, capellidom){
   var Url = accion;
   console.log(Url, dni, cdni, cnombres, capellidop, capellidom);
   console.log('Url: '+Url);
   console.log('Nombres: '+cnombres+' '+capellidop+' '+capellidom);
   $.ajax({
    url:Url,
    type:'GET',
    data:'dni='+dni,
    dataType:'json',
    success:function(data){
      var datos = data;
      console.log(datos);
        //var datos = datos_dni;
        console.log(datos);
        var nada = 'nada';
        if(datos===null){
          Swal.fire({
            text: "DNI no existe, verifique.",
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        }else{
          var xdni = document.getElementById(cdni);
          xdni.value = datos["numeroDocumento"];
          var xx = document.getElementById(capellidom);
          //console.log(xx);
          if (xx===null){
            var app = document.getElementById(capellidop);
            app.value = datos["apellidoPaterno"]+' '+datos["apellidoMaterno"];
          }else{
            var app = document.getElementById(capellidop);
            app.value = datos["apellidoPaterno"];
            var apm = document.getElementById(capellidom);
            apm.value = datos["apellidoMaterno"];
          }
          var xnom = document.getElementById(cnombres);
          xnom.value = datos["nombres"];
        }
      }
    });

   return false;
 };


 window.existe_dni_ante = function(accion) {
  return new Promise(function(resolve, reject) {
    var Url = accion;

    $.ajax({
      type: 'GET',
      url: Url,
      data: '',
      success: function(datos_dni) {
        var datos = datos_dni;
        console.log(datos);

        if (!(datos === '')) {
          Swal.fire({
            text: "DNI ya existe en la base de datos, verifique.",
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });

          resolve(true);
        } else {
          resolve(false);
        }
      },
      error: function(xhr, status, error) {
        console.error("Error en la solicitud AJAX:", error);
        reject(error);
      },
    });
  });
};


window.consulta_dni = function (accion, dni, cdni, cnombres, capellidop, capellidom) {
  var Url = accion;
    //console.log(Url, dni, cdni, cnombres, capellidop, capellidom);
    //$('.ajaxgif').removeClass('d-none');
/*    $.ajax({
        type: 'POST',
        url: Url,
        data: 'dni=' + dni,
        success: function (datos_dni) {
            $('.ajaxgif').addClass('d-none');
            //console.log(datos_dni);
            var datos = JSON.parse(datos_dni);
            //var datos = datos_dni;

            var nada = 'nada';
            if (datos === null) {
                Swal.fire({
                    text: "DNI no existe, verifique.",
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
            } else {
                var xdni = document.getElementById(cdni);
                xdni.value = datos["dni"];
                var xx = document.getElementById(capellidom);
                //console.log(xx);
                if (xx === null) {
                    var app = document.getElementById(capellidop);
                    app.value = datos["apellidoPaterno"] + ' ' + datos["apellidoMaterno"];
                } else {
                    var app = document.getElementById(capellidop);
                    app.value = datos["apellidoPaterno"];
                    var apm = document.getElementById(capellidom);
                    apm.value = datos["apellidoMaterno"];
                }
                var xnom = document.getElementById(cnombres);
                xnom.value = datos["nombres"];
            }
        }
      });*/
      $.ajax({
        type: 'POST',
        url: Url,
        data: { dni: dni },
    dataType: 'json', // <-- clave
    success: function (datos_dni) {
      $('.ajaxgif').addClass('d-none');
        console.log(datos_dni); // ya es objeto
        var datos = datos_dni; // no uses JSON.parse()

        if (datos === null) {
          Swal.fire({
            text: "DNI no existe, verifique.",
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        } else {
          var xdni = document.getElementById(cdni);
            //xdni.value = datos.dni;
            xdni.value = dni;

            var xx = document.getElementById(capellidom);
            if (xx === null) {
              var app = document.getElementById(capellidop);
              app.value = datos.apellidoPaterno + ' ' + datos.apellidoMaterno;
            } else {
              var app = document.getElementById(capellidop);
              app.value = datos.apellidoPaterno;
              var apm = document.getElementById(capellidom);
              apm.value = datos.apellidoMaterno;
            }
            var xnom = document.getElementById(cnombres);
            xnom.value = datos.nombres;
          }
        }
      });
      
      return false;
    };


    window.existe_dni = function (accion) {
      return new Promise(function (resolve, reject) {
        var Url = accion;

        $.ajax({
          type: 'GET',
          url: Url,
          data: '',
          success: function (datos_dni) {
            var datos = datos_dni;
            console.log(datos);

            if (!(datos === '')) {
              Swal.fire({
                text: "DNI ya existe en la base de datos, verifique.",
                icon: 'error',
                confirmButtonText: 'Aceptar',
              });

              resolve(true);
            } else {
              resolve(false);
            }
          },
          error: function (xhr, status, error) {
            console.error("Error en la solicitud AJAX:", error);
            reject(error);
          },
        });
      });
    };



/*window.vistaPrevia = function(campoId, ventanaId) {
  var oFReader = new FileReader();
  var xNomFile = document.getElementById(campoId);
  console.log(xNomFile);
  if (xNomFile.files.length > 0) {
    oFReader.readAsDataURL(xNomFile.files[0]);

    oFReader.onload = function (oFREvent) {
      document.getElementById(ventanaId).src = oFREvent.target.result;
    };
  }

};
*/

window.vistaPrevia = function(inputId, imagenId) {
  var input = document.getElementById(inputId);
  var imagen = document.getElementById(imagenId);

  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      imagen.src = e.target.result;
    };

    reader.readAsDataURL(input.files[0]);
  }
}

window.audio = function(code)
{
  //console.log(code);
  if (code != null) {
    var imageUrl = "{{ asset('audios') }}" + '/' + code;
    $("#grabacion").attr("src", imageUrl);
  }
  $("#audio").modal();

}


windows.esperarTecla = async function() {
  return new Promise((resolve) => {
        // Función de manejo de eventos
        function manejarTecla(event) {
            // Desvincular el evento después de presionar una tecla
            window.removeEventListener('keydown', manejarTecla);
            // Resolver la promesa con el código de la tecla
            resolve(event.code);
          }

        // Vincular la función de manejo de eventos al evento 'keydown'
        window.addEventListener('keydown', manejarTecla);
      });
}


/************/

window.visualizar = function(code, ruta, rutaimg) {
  var url = ruta + '/getvehiculoinfo/' + code;
    //console.log(url);
    $.ajax({
      data: {},
      type: "GET",
      dataType: "json",
      url: url,
    }) 
    .done(function(data, textStatus, jqXHR) {
    //console.log(data);
    var mode = data.modelo;
    //console.log(mode);

    // Utiliza una Promesa para realizar la segunda solicitud AJAX
    obtenerInformacionModelo(mode)
    .then(function(modeloData) {
      var myImageId = modeloData;
        //console.log(myImageId);
        if (myImageId != null) {
          var imageUrl = rutaimg + '/' + myImageId;
          //console.log(imageUrl);
          $("#imagen").attr("src", imageUrl);
        }
        $("#visualizar").modal();
      })
    .catch(function(error) {
      console.error("Error en la segunda solicitud: " + error);
    });
  })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error("Error en la primera solicitud: " + textStatus);
    });

  // Función que devuelve una Promesa para la segunda solicitud AJAX
  function obtenerInformacionModelo(modelo) {
    return new Promise(function(resolve, reject) {
    	var url = ruta + '/getvehiculomodelo/' + modelo;
      $.ajax({
        data: {},
        type: "GET",
        dataType: "text",
        url: url,
      })
      .done(function(modeloData) {
        //console.log(modeloData);
        resolve(modeloData);
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        reject(errorThrown);
      });
    });
  }
}


window.servicios = function(code, ruta, origen) {
	/***
	Origen : 1 - Clientes
	         2 - Vehiculos
          ***/

          if (origen==1) {
            var nuevaRuta = ruta + '/internos/' + code + "/0";
            window.location.href = nuevaRuta;
          } else {
            var url = ruta + '/getvehiculoinfo/' + code;	
            $.ajax({
             data: {},
             type: "GET",
             dataType: "json",
             url: url,
           })
            .done(function(data, textStatus, jqXHR) {
			//console.log(data);
			var clie = data.id_cliente;
			var vehi = data.id;
			//console.log(clie, vehi);
			var nuevaRuta = ruta + '/internos/' + clie + "/" + vehi;
			window.location.href = nuevaRuta;

		})
            .fail(function(jqXHR, textStatus, errorThrown) {
             console.error("Error en la primera solicitud: " + textStatus);
           });
          }
        }

        /********* Funciones para Clientes / Vehiculos / Internos **********/

        window.cargarClientes = function(ruta){
          var url = ruta + '/getClientes/' + code;
          var code = $("#idCliente").val();
          if(code!=""){
            $.ajax({
              data: {},
              type: "GET",
              dataType: "json",
              url: url,
            })
            .done(function( data, textStatus, jqXHR ) {
              $('#idCliente').empty();
              $('#idCliente').append("<option value='0'>Selecciona cliente</option>");
          //$("#motivo1").html("");
          data.forEach(function (item, index) {
            if(item.id == code)
              $("#idCliente").append('<option value="'+item.id+'" selected="selected">'+item.nombre+'</option>');
            else
              $("#idCliente").append('<option value="'+item.id+'">'+item.nombre+'</option>');
          });
        })
            .fail(function( jqXHR, textStatus, errorThrown ) {
             if ( console && console.log ) {
              console.log( "La solicitud a fallado: " +  textStatus);
            }
          });
          }
          else{
            $("#idCliente").html("");
          }
        }

        window.cargarVehiculos = function(ruta){


          var code = $("#idCliente").val();
          var vehi = $("#idVehiculo").val();
          var url = ruta + '/getvehiculos/' + code;    	
    //console.log(url);
      //console.log(code);
      if(code!=""){
        $.ajax({
          data: {},
          type: "GET",
          dataType: "json",
          url: url,
        })
        .done(function( data, textStatus, jqXHR ) {
          $('#idVehiculo').empty();
          $('#idVehiculo').append("<option value='0'>Selecciona vehiculo</option>");
          //$("#motivo1").html("");
          data.forEach(function (item, index) {
            if(item.id == vehi)
              $("#idVehiculo").append('<option value="'+item.id+'" selected="selected">'+item.placa+' - '+item.marca+' - '+item.modelo+' - '+item.color+' - '+item.propietario+'</option>');
            else
              $("#idVehiculo").append('<option value="'+item.id+'">'+item.placa+' - '+item.marca+' - '+item.modelo+' - '+item.color+' - '+item.propietario+'</option>');
          });
        })
        .fail(function( jqXHR, textStatus, errorThrown ) {
         if ( console && console.log ) {
          console.log( "La solicitud a fallado: " +  textStatus);
        }
      });
      }
      else{
        $("#idVehiculo").html("");
      }
    }



    window.hexToRgb = function(hex){
    // Elimina el símbolo '#' si está presente
    hex = hex.replace(/^#/, '');

    // Divide el valor hexadecimal en sus componentes RGB
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    cade = array(r,g,b);

    // Devuelve el valor RGB en formato 'rgb(r, g, b)'
    return cade;
  }

